/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProviderCredentialV2ListItem,
    ProviderCredentialV2ListItemFromJSON,
    ProviderCredentialV2ListItemFromJSONTyped,
    ProviderCredentialV2ListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2ListItemPaginationWrapper
 */
export interface ProviderCredentialV2ListItemPaginationWrapper {
    /**
     * 
     * @type {Array<ProviderCredentialV2ListItem>}
     * @memberof ProviderCredentialV2ListItemPaginationWrapper
     */
    items?: Array<ProviderCredentialV2ListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderCredentialV2ListItemPaginationWrapper
     */
    totalItems?: number;
}

export function ProviderCredentialV2ListItemPaginationWrapperFromJSON(json: any): ProviderCredentialV2ListItemPaginationWrapper {
    return ProviderCredentialV2ListItemPaginationWrapperFromJSONTyped(json, false);
}

export function ProviderCredentialV2ListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2ListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ProviderCredentialV2ListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function ProviderCredentialV2ListItemPaginationWrapperToJSON(value?: ProviderCredentialV2ListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ProviderCredentialV2ListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


